import {Prompt} from "./types";
import {gigaParty} from "../party";

export const completionsCreate = (prompts: Prompt[]) => {
    return new Promise((resolve, reject) => {
        const id = Math.random().toString(36).substring(7);

        gigaParty.send(JSON.stringify({
            id,
            key: 'gigakit.self.ai.completion',
            data: {
                messages: prompts
            }
        }));

        gigaParty.addEventListener('message', (event: MessageEvent) => {
            const message = JSON.parse(event.data)
            if (message.id !== id) return;

            resolve(message.data);
        })

    });
};
